import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

const mockRows = [
  { cat: 'Shoes', name: 'Creator A', status: 'active' },
  { cat: 'Jerseys', name: 'Creator B', status: 'new' },
  { cat: 'Accessories', name: 'Creator C', status: 'active' },
  { cat: 'Bags', name: 'Creator D', status: 'active' },
];

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden">
      <div className="pointer-events-none absolute -top-24 right-0 h-72 w-72 rounded-full bg-emerald-100/60 blur-3xl" aria-hidden="true" />
      <div className="pointer-events-none absolute -left-24 bottom-0 h-72 w-72 rounded-full bg-amber-100/60 blur-3xl" aria-hidden="true" />

      <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-4 py-14 md:px-6 md:py-20 lg:grid-cols-2">
        <div className="w-full">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-50 px-3 py-1 text-xs font-semibold text-emerald-700">
            <i className="ri-sparkling-line w-4 h-4 flex items-center justify-center" aria-hidden="true" />
            {t('hero.badge')}
          </span>

          <h1 className="mt-5 text-3xl font-bold leading-tight text-stone-900 md:text-4xl lg:text-5xl">
            {t('hero.title')}
          </h1>

          <p className="mt-5 max-w-xl text-base leading-relaxed text-stone-600 md:text-lg">
            {t('hero.subtitle')}
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-emerald-600 px-6 py-3 text-sm font-semibold text-white hover:bg-emerald-700 whitespace-nowrap cursor-pointer"
            >
              {t('hero.ctaSpreadsheet')}
              <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center" aria-hidden="true" />
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-amber-500 px-6 py-3 text-sm font-semibold text-white hover:bg-amber-600 whitespace-nowrap cursor-pointer"
            >
              {t('hero.ctaBuy')}
              <i className="ri-shopping-bag-3-line w-4 h-4 flex items-center justify-center" aria-hidden="true" />
            </a>
          </div>
        </div>

        {/* Spreadsheet mockup */}
        <div className="w-full">
          <div className="overflow-hidden rounded-lg border border-stone-200 bg-white">
            <div className="flex items-center justify-between border-b border-stone-200 bg-stone-50 px-4 py-3">
              <div className="flex items-center gap-2">
                <span className="flex h-7 w-7 items-center justify-center rounded-md bg-emerald-600 text-white">
                  <i className="ri-table-line w-4 h-4 flex items-center justify-center" aria-hidden="true" />
                </span>
                <span className="text-sm font-semibold text-stone-800">{t('hero.mockupTitle')}</span>
              </div>
              <span className="flex gap-1.5" aria-hidden="true">
                <span className="h-2.5 w-2.5 rounded-full bg-stone-300" />
                <span className="h-2.5 w-2.5 rounded-full bg-stone-300" />
                <span className="h-2.5 w-2.5 rounded-full bg-stone-300" />
              </span>
            </div>

            <div className="px-4 py-3">
              <div className="flex items-center gap-2 rounded-md border border-stone-200 bg-stone-50 px-3 py-2">
                <i className="ri-search-line w-4 h-4 flex items-center justify-center text-stone-400" aria-hidden="true" />
                <span className="text-sm text-stone-400">{t('hero.mockupSearch')}</span>
              </div>
            </div>

            <div className="overflow-x-auto px-4 pb-4">
              <table className="w-full text-left text-sm">
                <thead>
                  <tr className="border-b border-stone-200 text-xs font-semibold text-stone-400">
                    <th className="py-2 pr-4">{t('hero.mockupColCategory')}</th>
                    <th className="py-2 pr-4">{t('hero.mockupColName')}</th>
                    <th className="py-2">{t('hero.mockupColStatus')}</th>
                  </tr>
                </thead>
                <tbody>
                  {mockRows.map((row) => (
                    <tr key={row.name} className="border-b border-stone-100 last:border-0">
                      <td className="py-2.5 pr-4">
                        <span className="rounded-full bg-emerald-50 px-2.5 py-0.5 text-xs font-medium text-emerald-700">
                          {row.cat}
                        </span>
                      </td>
                      <td className="py-2.5 pr-4 font-medium text-stone-700">{row.name}</td>
                      <td className="py-2.5">
                        {row.status === 'new' ? (
                          <span className="rounded-full bg-amber-100 px-2.5 py-0.5 text-xs font-medium text-amber-700">
                            {t('hero.mockupStatusNew')}
                          </span>
                        ) : (
                          <span className="rounded-full bg-emerald-100 px-2.5 py-0.5 text-xs font-medium text-emerald-700">
                            {t('hero.mockupStatusActive')}
                          </span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="border-t border-stone-100 px-4 py-2.5 text-xs text-stone-400">{t('hero.mockupNote')}</div>
          </div>
        </div>
      </div>
    </section>
  );
}